import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import numberWithCommas from "../common/number";
import Modelupload from "../wms/modelupload";
import BranchContext from "./../context/branch";
const RenderRegisterList = ({
  list,
  lastBookElementRef,
  handleCancleSubmit,
  handleConfirmSubmitcall,
  onProcess,
}) => {
  const { currentBranch } = useContext(BranchContext);
  const [calllist, setcalllist] = useState([]);
  const [askConfirm, setaskConfirm] = useState(false);
  const handelClick = (even) => {
    setcalllist(even);
    setaskConfirm(true);
    onProcess(true);
  };
  const onCancel = (even) => {
    setaskConfirm(false);
    // onProcess(false);
  };
  const url =
    "https://wms.advanceagro.net/wsface/api/face/RealImage?IdentityID=";

  return (
    <>
      <Modelupload
        isOpen={askConfirm}
        onConfirm={handleConfirmSubmitcall}
        onCancel={onCancel}
        //message={message}
        listcall={calllist}
        // reload={handlereload}
      />
      {list &&
        url &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div key={item.AutoID}>
                <div className="card  m-2 ">
                  <div ref={lastBookElementRef} className="row m-1">
                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1 ">
                      <div style={{ fontSize: "22px" }}>
                        <span className="badge rounded-pill bg-primary">
                          {item.No}
                        </span>
                      </div>
                      <div style={{ fontSize: "14px" }}>{item.Weight_no}</div>
                      <div style={{ fontSize: "14px" }}>
                        {item.Customer_Name}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {item.CustomerTypeName}
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div className="mytooltip tooltip-effect-1">
                        <span className="tooltip-item">
                          <span className="d-none d-md-inline text-black pr-2">
                            {currentBranch._id==="505" ? <div className="col-auto">
                                <img
                              className="rounded-circle ms-2"
                              src={url + item.Tag + "&size=320"}
                              alt=""
                              style={{
                                maxHeight: 50,
                                Width: 300,
                              }}
                            />
                            </div>:null}
                          
                            <div className="col-auto">
                               {item.Driver_Name}{" "}
                            </div>
                           
                          </span>
                        </span>

                        {currentBranch._id==="505" ? <span className="tooltip-content clearfix">
                          <img
                            className="rounded-circle ms-2"
                            src={url + item.Tag + "&size=320"}
                            alt=""
                            style={{
                              width: "100%",
                              minHeight: "300px",
                              minWidth: "300px",
                            }}
                          />

                          <span className="tooltip-text"></span>
                        </span>:null}
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          autoid :
                          <small style={{ fontSize: "14px" }}> {item.AutoID}</small>{" "}
                        </h6>
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          ใบนำส่ง :
                          <small style={{ fontSize: "14px" }}> {item.DO}</small>{" "}
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วัตถุประสงค์ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.aim_name}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ประเภทสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.type_name}
                          </small>
                        </h6>
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.ProductName}
                          </small>
                        </h6>
                      </div>
                      <div></div>
                    </div>
                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ประเภทรถ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.truck_typename}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหัว :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.Driven_no}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหาง :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.second_driven_no}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วันที่ลงสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.queue_date}
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div>
                        <h6>
                          {" "}
                          เข้า :
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge rounded-pill bg-info text-dark">
                              {numberWithCommas(item.receive_weightin)}
                            </span>
                          </small>
                        </h6>
                      </div>

                      <div>
                        <h6>
                          {" "}
                          ออก :
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge rounded-pill bg-warning text-dark">
                              {numberWithCommas(item.receive_weightout)}
                            </span>
                          </small>
                        </h6>
                      </div>

                      <div>
                        <h6>
                          {" "}
                          สุทธิ :
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge rounded-pill bg-success">
                              {numberWithCommas(item.receive_weightnet)}
                            </span>
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สถานที่ลง :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.storename}
                          </small>
                        </h6>
                      </div>

                      <Link
                        style={{ width: "50px" }}
                        to={`/register/${item.AutoID}`}
                      >
                        <button
                          type="button"
                          className="btn btn-primary btn-sm m-2"
                        >
                          {item.receive_weightin > 0 ? "View" : "Edit"}
                        </button>
                      </Link>
                      {item.appcode == "VMS" && (
                        <Button
                          type="button"
                          color="success"
                          disabled={true}
                          value={item.ID}
                          onClick={() =>
                            handelClick([item.identityno, item.Driver_Name])
                          }
                          className="btn btn-primary btn-sm m-2"
                        >
                          Upload
                        </Button>
                      )}
                                {currentBranch._id == "505" && (
                        <Button
                          type="button"
                          color="success"
                          disabled={true}
                          value={item.ID}
                          onClick={() =>
                            handelClick([item.identityno, item.Driver_Name])
                          }
                          className="btn btn-primary btn-sm m-2"
                        >
                          Upload
                        </Button>
                      )}
                    </div>

                    {/* </div> */}
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div key={item.AutoID}>
                <div className="card m-2">
                  {/* <div className="card-body"> */}
                  <div className="row m-1">
                    <div className="col-xs-6 col-sm-4 col-md-2  ">
                      <div style={{ fontSize: "22px" }}>
                        <span className="badge rounded-pill bg-primary">
                          {item.No}
                        </span>
                      </div>
                      <div style={{ fontSize: "14px" }}>{item.Weight_no}</div>
                      <div style={{ fontSize: "14px" }}>
                        {item.Customer_Name}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        {item.CustomerTypeName}
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1 d-flex align-items-center mt-2">
                      <div className="mytooltip tooltip-effect-1">
                        <span className="tooltip-item">
                          <span className="d-none d-md-inline text-black pr-2">
                          {currentBranch._id==="505" ? <div className="col-auto">
                                <img
                              className="rounded-circle ms-2"
                              src={url + item.Tag + "&size=320"}
                              alt=""
                              style={{
                                maxHeight: 50,
                                Width: 300,
                              }}
                            />
                            </div>:null}
                          
                            <div className="col-auto">
                               {item.Driver_Name}{" "}
                            </div>
                          </span>
                        </span>

                        {currentBranch._id==="505" ? <span className="tooltip-content clearfix">
                          <img
                            className="rounded-circle ms-2"
                            src={url + item.Tag + "&size=320"}
                            alt=""
                            style={{
                              width: "100%",
                              minHeight: "300px",
                              minWidth: "300px",
                            }}
                          />

                          <span className="tooltip-text"></span>
                        </span>:null}
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          autoid :
                          <small style={{ fontSize: "14px" }}> {item.AutoID}</small>{" "}
                        </h6>
                      </div>
                      {/* <div>
                          <span
                            style={{ fontSize: "14px" }}
                            className=" text-black pr-0 "
                          >
                            <img
                              className="card rounded-circle "
                              src={url + item.Tag + "&size=320"}
                              style={{
                                width: "100%",
                                maxHeight: 50,
                                maxWidth: 50,
                              }}
                            />
                            {item.Driver_Name}
                          </span>
                        </div> */}
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          ใบนำส่ง :
                          <small style={{ fontSize: "14px" }}> {item.DO}</small>{" "}
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วัตถุประสงค์ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.aim_name}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ประเภทสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.type_name}
                          </small>
                        </h6>
                      </div>

                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.ProductName}
                          </small>
                        </h6>
                      </div>
                      <div></div>
                    </div>
                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ประเภทรถ :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.truck_typename}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหัว :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.Driven_no}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          ทะเบียนหาง :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.second_driven_no}
                          </small>
                        </h6>
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          วันที่ลงสินค้า :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.queue_date}
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div>
                        <h6>
                          {" "}
                          เข้า :
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge rounded-pill bg-info text-dark">
                              {numberWithCommas(item.receive_weightin)}
                            </span>
                          </small>
                        </h6>
                      </div>

                      <div>
                        <h6>
                          {" "}
                          ออก :
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge rounded-pill bg-warning text-dark">
                              {numberWithCommas(item.receive_weightout)}
                            </span>
                          </small>
                        </h6>
                      </div>

                      <div>
                        <h6>
                          {" "}
                          สุทธิ :
                          <small style={{ fontSize: "18px" }}>
                            {" "}
                            <span className="badge rounded-pill bg-success">
                              {numberWithCommas(item.receive_weightnet)}
                            </span>
                          </small>
                        </h6>
                      </div>
                    </div>

                    <div className="col-xs-6 col-sm-4 col-md-2 lg-1">
                      <div style={{ fontSize: "14px" }}>
                        <h6>
                          {" "}
                          สถานที่ลง :
                          <small style={{ fontSize: "14px" }}>
                            {" "}
                            {item.storename}
                          </small>
                        </h6>
                      </div>

                      <Link
                        style={{ width: "50px" }}
                        to={`/register/${item.AutoID}`}
                      >
                        <button
                          type="button"
                          className="btn btn-primary btn-sm m-2"
                        >
                          {item.receive_weightin > 0 ? "View" : "Edit"}
                        </button>
                      </Link>
                      {item.appcode == "VMS" && (
                        <Button
                          type="button"
                          color="success"
                          //disabled ={true}
                          value={item.AutoID}
                          onClick={() =>
                            handelClick([item.identityno, item.Driver_Name])
                          }
                          className="btn btn-primary btn-sm m-2"
                        >
                          Upload
                        </Button>
                      )}
                         {currentBranch._id == "505" && (
                        <Button
                          type="button"
                          color="success"
                         
                          value={item.ID}
                          onClick={() =>
                            handelClick([item.identityno, item.Driver_Name])
                          }
                          className="btn btn-primary btn-sm m-2"
                        >
                          Upload
                        </Button>
                      )}
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default RenderRegisterList;
